import { PurposeModel } from './PreferenceModel';
import { getText } from '../../TranslationService';
import { ToggleSwitch } from '../shared/UiStates/ToggleSwitch';

type PurposeComponentModel = {
  purpose: PurposeModel;
  onPurposeChangedHandler: (id: number, isOptedIn: boolean) => void;
};

const LegalDescription = ({ legalDescription }: { legalDescription: string }) => {
  const legalDescriptionLines = String(legalDescription)
    .split('\n')
    .map((line) => {
      let isBulletRow = false;
      const includesAsterisk = line.indexOf('*');
      isBulletRow = includesAsterisk > -1 ? true : isBulletRow;

      if (isBulletRow) {
        const lineWithoutBullet = line.replace('*', '');
        return (
          <div class="bullet-point">
            <span class="bullet">&#8226;</span> <span>{lineWithoutBullet}</span>
          </div>
        );
      } else {
        return <div class="legal-description-title">{line}</div>;
      }
    });

  return <div>{legalDescriptionLines.map((line) => line)}</div>;
};

const ToggleColumn = ({ purpose, onPurposeChangedHandler }: PurposeComponentModel) => {
  const changeHandler = (event: any) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    onPurposeChangedHandler(purpose.id, !!value);
  };
  return <ToggleSwitch uid={`purpose${purpose.id}`} isChecked={purpose.optedIn} onChangeHandler={changeHandler} />;
};
export const Purpose = ({ purpose, onPurposeChangedHandler }: PurposeComponentModel) => {
  return (
    <div>
      <section class="cc-accordion-flex">
        <div class="col-info">
          {purpose.shouldDisplayTitle ? (
            <div class="ccm-row-option">
              <div class="ccm-col-description ccm-purpose-title">{getText(`option_name_${purpose.name}`)}</div>
            </div>
          ) : (
            ''
          )}

          <div class="ccm-row-option">
            <div class="ccm-row-description"> {getText(`option_description_${purpose.name}`)}</div>
          </div>

          {purpose.shouldDisplayLegalDescription ? (
            <div class="ccm-row-option">
              <div class="wrap-collabsible">
                <input
                  class="collapse toggle-checkbox"
                  id={`legal-description-checkbox-${purpose.id}`}
                  type="checkbox"
                />
                <label for={`legal-description-checkbox-${purpose.id}`} class="lbl-toggle">
                  {getText('legal_description')}
                </label>
                <div class="collapsible-content">
                  <LegalDescription legalDescription={getText(`option_legal_description_${purpose.name}`)} />
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        <ToggleColumn {...{ purpose, onPurposeChangedHandler }} />
      </section>
    </div>
  );
};
